import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
      <path
        d='M11.9930163,21.9963673 L12.0128105,21.9980525 C12.1951544,22.0110492 12.3810727,21.9589954 12.5347763,21.8418937 L12.6228463,21.7638269 L18.7558912,15.4664561 C18.8609669,15.3585651 18.9300335,15.2277083 18.963092,15.0896263 L18.9811345,14.9849561 C18.9933282,14.9272795 19,14.867543 19,14.8062068 C19,14.3980557 18.7045732,14.060744 18.321277,14.0073597 L18.214719,14 L5.79942586,14 C5.40186868,14 5.07331213,14.3032992 5.02131352,14.6968093 L5.01921298,14.7187051 C4.96209137,14.9793788 5.03233929,15.2635364 5.22996399,15.4664561 L11.3630089,21.7638269 C11.5353652,21.9408013 11.7679231,22.0183164 11.9930163,21.9963673 Z M11.9929426,20.1296002 L7.59222773,15.6126923 L16.3926105,15.6126923 L11.9929426,20.1296002 Z'
      />
      <path
        d='M11.9930163,2.00363269 L12.0128105,2.00194751 C12.1951544,1.98895077 12.3810727,2.04100457 12.5347763,2.15810629 L12.6228463,2.23617305 L18.7558912,8.53354386 C18.8609669,8.64143492 18.9300335,8.77229171 18.963092,8.91037368 L18.9811345,9.01504394 C18.9933282,9.07272052 19,9.13245696 19,9.19379321 C19,9.60194428 18.7045732,9.93925604 18.321277,9.99264028 L18.214719,10 L5.79942586,10 C5.40186868,10 5.07331213,9.69670083 5.02131352,9.3031907 L5.01921298,9.28129487 C4.96209137,9.02062122 5.03233929,8.73646363 5.22996399,8.53354386 L11.3630089,2.23617305 C11.5353652,2.0591987 11.7679231,1.98168359 11.9930163,2.00363269 Z M11.9929426,3.87039975 L7.59222773,8.38730766 L16.3926105,8.38730766 L11.9929426,3.87039975 Z'
       
      />
  </svg>
);
